import { locationSelector } from 'sfproxy/selectors'
import { entitySelector } from 'wordpress/selectors'
import { createDenormalizedSelector } from 'entities/selectors'
import { rateSchema } from 'grs/schemas'
import { isHostCanada } from 'shared/country'

const stateSelector = state => (state.carParkRates instanceof Array ? state.carParkRates : [])

export const ratesSelector = createDenormalizedSelector(stateSelector, [rateSchema])

export const subscriptionsSelector = createSelector(ratesSelector, rates => rates.filter(rate => rate.isMonthlyPass))

export const locationWithBrandSelector = createSelector(
    locationSelector,
    entitySelector('brands'),
    (location, brands) =>
        location
            ? {
                  ...location,
                  brandLogo: brands[location.brand] ? brands[location.brand].logo : undefined,
              }
            : location
)

export const canBuySelector = createSelector(locationSelector, location =>
    !!location.grsId && isHostCanada && location.address.country !== 'CA'
        ? false
        : !!location.grsId && location.reservationsEnabled
)
